(function () {
  if (window.__announcementBarProgressInitialized) return;
  window.__announcementBarProgressInitialized = true;

  const controllers = new Map();

  function decode(value) {
    return value ? decodeURIComponent(value) : '';
  }

  function formatMoney(amount, formatString) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(amount, formatString || Shopify.money_format);
    }

    const number = (amount / 100).toFixed(2);
    return formatString ? formatString.replace(/\{\{\s*amount\s*\}\}/, number) : number;
  }

  class AnnouncementBarController {
    constructor(root) {
      this.root = root;
      this.sectionId = root.dataset.sectionId;
      this.progressEnabled = root.dataset.progressEnabled === 'true';
      this.onCartUpdate = this.onCartUpdate.bind(this);
      this.unsubscribe =
        typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'
          ? subscribe(PUB_SUB_EVENTS.cartUpdate, this.onCartUpdate)
          : null;
      this.progressWrap = this.root.querySelector('.announcement-bar--progress .fsb-wrap');
    }

    async onCartUpdate() {
      if (!this.progressEnabled) return;
      try {
        const cart = await this.fetchCart();
        const hasProgress = !!this.root.querySelector('.announcement-bar--progress');

        if (!hasProgress || !this.progressWrap || cart.item_count === 0) {
          await this.reloadSection();
          return;
        }

        this.updateProgressWithCart(cart);
      } catch (error) {
        console.warn('Announcement bar progress update failed', error);
      }
    }

    async fetchCart() {
      const cartPath = (window.routes && window.routes.cart_url) || '/cart';
      const response = await fetch(`${cartPath}.js`);
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    }

    updateProgressWithCart(cart) {
      if (!this.progressWrap) return;
      const threshold = parseInt(this.progressWrap.dataset.threshold, 10);
      if (!threshold) return;

      const subtotal =
        typeof cart.total_price === 'number'
          ? cart.total_price
          : typeof cart.items_subtotal_price === 'number'
          ? cart.items_subtotal_price
          : 0;

      const remaining = Math.max(threshold - subtotal, 0);
      let percent;
      if (subtotal >= threshold) {
        percent = 100;
      } else {
        percent = Math.floor((subtotal * 100) / threshold);
        percent = Math.min(percent, 100);
        if (subtotal > 0 && percent === 0) percent = 1;
      }

      this.progressWrap.style.setProperty('--fsb-progress', `${percent}%`);
      const track = this.progressWrap.querySelector('.fsb-track');
      if (track) {
        track.setAttribute('aria-valuenow', `${percent}`);
      }

      const moneyFormat = decode(this.progressWrap.dataset.moneyFormat);
      const formattedRemaining = formatMoney(remaining, moneyFormat);

      const progressTemplate = decode(this.progressWrap.dataset.progressTemplate);
      const progressTextTemplate = decode(this.progressWrap.dataset.progressTextTemplate);
      const unlockedHtml = decode(this.progressWrap.dataset.unlockedHtml);
      const unlockedText = decode(this.progressWrap.dataset.unlockedText);
      const fillColorBase = decode(this.progressWrap.dataset.fillColorBase);
      const fillColorComplete = decode(this.progressWrap.dataset.fillColorComplete);

      const message = this.progressWrap.querySelector('.fsb-msg');

      if (remaining <= 0) {
        if (message && unlockedHtml) {
          message.innerHTML = unlockedHtml;
        }
        if (track && unlockedText) {
          track.setAttribute('aria-valuetext', unlockedText);
        }
        this.progressWrap.style.setProperty('--fsb-fill-color', fillColorComplete || 'var(--free-shipping-progress-complete, #2e7d32)');
      } else {
        if (message && progressTemplate) {
          message.innerHTML = progressTemplate.replace('__amount__', formattedRemaining);
        }
        if (track && progressTextTemplate) {
          track.setAttribute('aria-valuetext', progressTextTemplate.replace('__amount__', formattedRemaining));
        }
        this.progressWrap.style.setProperty('--fsb-fill-color', fillColorBase || 'rgb(var(--color-button, var(--color-foreground, 0,0,0)))');
      }
    }

    async reloadSection() {
      if (!this.sectionId) return;
      const url = `${window.location.pathname}?section_id=${this.sectionId}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error('Section fetch failed');
      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const replacement = doc.querySelector(`#shopify-section-${this.sectionId} [data-announcement-section]`);
      const current = document.querySelector(`#shopify-section-${this.sectionId} [data-announcement-section]`);
      if (!replacement || !current) return;

      this.cleanup();
      current.replaceWith(replacement);
      requestAnimationFrame(init);
    }

    cleanup() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }
      controllers.delete(this.sectionId);
    }
  }

  function init() {
    document.querySelectorAll('[data-announcement-section]').forEach((element) => {
      const sectionId = element.dataset.sectionId;
      const existing = controllers.get(sectionId);
      if (existing) return;
      controllers.set(sectionId, new AnnouncementBarController(element));
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
  document.addEventListener('shopify:section:unload', (event) => {
    const controller = controllers.get(event.detail.sectionId);
    if (controller) controller.cleanup();
  });
})();
